<template>
    <label class="selectbox-label" @click="toggleSelectbox" @blur="show = false" tabindex="0">

        <span class="current-element">{{ currentElement ? currentElement : placeholder }}</span>

        <img src="@/assets/images/icons/arrow_down.svg" alt="arrow down" class="arrow">

        <transition name="fade">
            <ul class="options-list" v-show="show">

                <li :class="['option', {'active': isOptionActive(option)}]"
                    v-for="option in options"
                    :key="option.id"
                    @click="setActiveOption(option)"
                    tabindex="0"
                >
                    <span>
                        {{ option }}
                    </span>

                    <img src="@/assets/images/icons/check-mark_pink.svg"
                         alt="check mark"
                         class="check-mark"
                         v-show="isOptionActive(option)">
                </li>

            </ul>
        </transition>

    </label>
</template>

<script>
    export default {
        name: "Selectbox",
        props: {
            placeholder: {
                type: String,
                default: 'Select element'
            },
            value: {
                type: String,
                default: ''
            },
            options: {
                type: Array,
                default: () => {
                    return []
                }
            }
        },
        data() {
            return {
                currentElement: null,
                show: false
            }
        },
        methods: {
            isOptionActive(option) {
                return this.currentElement === option
            },
            setActiveOption(option) {
                this.currentElement = option
            },
            toggleSelectbox(event) {
                if (event.target.nodeName === 'LABEL' || event.target.className === 'current-element' || event.target.className === 'arrow') {
                    this.show = !this.show
                }
            }
        },
        mounted() {
            this.currentElement = this.value
        },
        watch: {
            value(value) {

                this.setActiveOption(value)

            },
            currentElement(value) {
                this.$emit('input', value)
            }
        }
    }
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .3s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>